import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthProvider';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../../../src/assets/images/dwlogo_wide.png';
import LogoHeader from '../../shared/layout/components/misc/LogoHeader';
import LanguageSelector from '../../shared/layout/components/misc/LanguageSelector';
import LoginForm from '../../shared/layout/components/forms/LoginForm';
import Options from '../../shared/layout/components/misc/Options';

import GlassCard from "../../shared/layout/components/cards/GlassCard";
import GradientBackground from "../../shared/layout/components/containers/GradientBackground";

const LoginPage = () => {
    const { t, i18n } = useTranslation();
    const { login } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage') || 'en');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (searchParams.get('source') === 'woocommerce') {
            localStorage.setItem('lastVisitedPath', '/integration');
        }
    }, [searchParams]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoginError('');
        setIsSubmitting(true);
        try {
            console.log('Starting login...');
            const { targetPath } = await login(email, password);
            console.log('Login sequence completed, navigating to:', targetPath);
            navigate(targetPath, { replace: true });
        } catch (error) {
            console.error('Login error:', error);
            setLoginError(t('LoginPage.login_error'));
            setIsSubmitting(false);
        }
    };

    const handleLanguageChange = (language) => {
        setSelectedLanguage(language);
        localStorage.setItem('selectedLanguage', language);
        i18n.changeLanguage(language);
    };


    return (
        <GradientBackground>
            <GlassCard>
                <HeaderTop>
                    <div />
                    <LanguageSelector
                        selectedLanguage={selectedLanguage}
                        onLanguageChange={handleLanguageChange}
                        align="flex-end"
                    />
                </HeaderTop>
                <LogoHeader logoSrc={Logo} title="DigiWarranty" />
                <HeaderText>
                    <h2>{t('LoginPage.title')}</h2>
                    <p>{t('LoginPage.subtitle')}</p>
                </HeaderText>
                <LoginForm
                    email={email}
                    setEmail={setEmail}
                    password={password}
                    setPassword={setPassword}
                    onSubmit={handleSubmit}
                    error={loginError}
                    loading={isSubmitting}
                />
                <Options
                    onRegisterClick={() => navigate('/register')}
                    onForgotPasswordClick={() => navigate('/forgot-password')}
                />
            </GlassCard>
        </GradientBackground>
    );
};

export default LoginPage;

const HeaderTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.75rem;
`;

const HeaderText = styled.div`
    text-align: center;
    margin-bottom: 0.5rem;

    h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #1a0621;
        margin-bottom: 0.4rem;
    }

    p {
        color: #6b7280;
        font-size: 0.95rem;
        margin: 0;
    }
`;
